// NewsSlider.js
import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Button from '../UI/Button';

const NewsSlider = ({ news, autoPlayInterval = 5000 }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev === news.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev === 0 ? news.length - 1 : prev - 1));
    };

    // Auto-play do slider
    useEffect(() => {
        let interval;
        
        if (isAutoPlaying) {
            interval = setInterval(() => {
                nextSlide();
            }, autoPlayInterval);
        }

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [isAutoPlaying, currentSlide, autoPlayInterval]);

    // Pausa o auto-play quando o usuário interage
    const handleManualNavigation = (callback) => {
        setIsAutoPlaying(false);
        callback();
        // Reinicia o auto-play após 10 segundos de inatividade
        setTimeout(() => {
            setIsAutoPlaying(true);
        }, 10000);
    };

    return (
        <div 
            className="relative w-full  h-64 sm:h-80 md:h-[420px] lg:h-[560px] overflow-hidden"
            onMouseEnter={() => setIsAutoPlaying(false)}
            onMouseLeave={() => setIsAutoPlaying(true)}
        >
            {/* Slides */}
            <div
                className="absolute w-full h-full  transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
                {news.map((item, index) => (
                    <div
                        key={item.id}
                        className="absolute top-0 left-0 w-full h-full"
                        style={{ left: `${index * 100}%` }}
                    >
                        <img
                            src={item.image}
                            alt={item.title}
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent p-6 md:p-12">
                            <div className="max-w-3xl rounded-3xl border border-white/10 bg-black/35 p-5 text-white shadow-2xl backdrop-blur-xs md:p-7">
                                <h2 className="mb-3 text-2xl font-bold leading-tight md:text-4xl">{item.title}</h2>
                                <p className="mb-5 text-sm leading-6 text-white/90 md:text-lg md:leading-8 line-clamp-2 md:line-clamp-3">
                                    {item.description}
                                </p>
                                <div className="flex flex-col space-y-2 sm:flex-row sm:space-x-4 sm:space-y-0">
                                    <Button variant="primary" onClick={() => (window.location.href = '/feed')}>
                                        Aceder à Plataforma
                                    </Button>
                                    <Button
                                        variant="secondary"
                                        onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScAsdfxE5E4kbRW3NtoFy0QoyHQkqdOzvqNrt69w_p7Rkzmsg/viewform', '_blank')}
                                    >
                                        Inscrição
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Navigation buttons */}
            <button
                onClick={() => handleManualNavigation(prevSlide)}
                className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/30 hover:bg-white/50 p-3 transition-all duration-200 rounded-full backdrop-blur-sm"
                aria-label="Anterior"
            >
                <FaChevronLeft className="text-white text-xl" />
            </button>
            <button
                onClick={() => handleManualNavigation(nextSlide)}
                className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/30 hover:bg-white/50 p-3 transition-all duration-200 rounded-full backdrop-blur-sm"
                aria-label="Proximo"
            >
                <FaChevronRight className="text-white text-xl" />
            </button>

            {/* Dots indicator */}
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
                {news.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => handleManualNavigation(() => setCurrentSlide(index))}
                        className={`w-2 h-2 rounded-full transition-all duration-300 ${
                            currentSlide === index 
                                ? 'bg-white w-6' 
                                : 'bg-white/50 hover:bg-white/70'
                        }`}
                        aria-label={`Slide ${index + 1}`}
                    />
                ))}
            </div>
            
            {/* Indicador de tempo restante (opcional) */}
            {isAutoPlaying && (
                <div className="absolute bottom-0 left-0 h-1 bg-emerald-500 transition-all duration-300"
                    style={{ width: `${((currentSlide + 1) / news.length) * 100}%` }}
                />
            )}
        </div>
    );
};

export default NewsSlider;